import { NavLink } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { colors } from '../../utils/colors';

export const VersionContainer = styled.div`
  margin-top: 20px;
  text-align: center;
  font-size: 14px;
  color: ${colors.cinza};
  background-color: white;
`;

export const ContainerFooter = styled.div`
  border-top: 5px solid ${colors.verde};
  padding-top: 30px;
  margin-top: 40px;
  background-color: white;
`;

export const ConteudoContainerLimit = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  max-width: 1400px;
  margin: 0px auto;

  @media (max-width: 1249px) {
    justify-content: center;
  }
`;

export const ColumContainerFooter = styled.div`
  width: 20%;
  min-width: 250px;
  padding-left: 10px;

  img {
    width: 100%;
  }

  @media (max-width: 1249px) {
    padding-top: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
  }
`;

export const TituloColumContaianer = styled.div<{ secundary?: boolean }>`
  color: ${colors.verde};
  font-size: 16px;
  font-weight: 700;
  text-transform: uppercase;
  margin-bottom: 10px;

  ${(props) =>
    props.secundary &&
    css`
      text-transform: capitalize;
      font-weight: 500;
    `};
`;

export const Linkcomponent = styled(NavLink)`
  color: ${colors.cinza};
  text-decoration: none;
  font-weight: 500;
  display: block;

  &:hover {
    color: ${colors.verde};
  }
`;

export const ListColumContainer = styled.div<{ secundary?: boolean }>`
  color: ${colors.cinza};
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  margin-bottom: 10px;

  ${(props) =>
    props.secundary &&
    css`
      margin-bottom: 0px;
      display: flex;

      &:hover {
        color: ${colors.verde};
      }
    `};
`;
